import styled from '@emotion/styled'

const commonFont = '"Segoe UI", Arial'

export const Container = styled.section`
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 15px;
  position: relative;
  min-height: 700px;
`

export const Wrapper = styled.div`
  position: relative;
  padding-top: 30px;

  @media (min-width: 968px) {
    padding-top: 105px;
  }
`

export const BackgroundSvg = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  top: 0;
`

export const Content = styled.div`
  position: relative;
  z-index: 1;
  max-width: 650px;
`

export const Title = styled.h2`
  font: 400 16px ${commonFont};
  text-transform: uppercase;
  margin-bottom: 25px;
`

const titleBase = `
  display: block;
  font-size: 55px;
  line-height: 65px;
  font-family: ${commonFont};
`

export const BlackTitle = styled.span`
  ${titleBase}
  color: #1e1e1e;
  font-weight: 700;
`

export const PrimaryTitle = styled.span`
  ${titleBase}
  color: #78be20;
  font-weight: 750;
  margin-bottom: 25px;
`

export const Info = styled.p`
  font: 20px ${commonFont};
  line-height: 30px;
`

export const NavWrapper = styled.div`
  width: 100%;
  margin-top: 40px;

  @media (min-width: 968px) {
    position: absolute;
    z-index: 1;
    bottom: 0;
    margin-top: 0;
  }
`

export const NavInfo = styled.strong`
  font: bold 20px ${commonFont};
  line-height: 30px;
  display: block;
`

export const Button = styled.strong`
  font: bold 16px ${commonFont};
  line-height: 24px;
  background: #78be20;
  padding: 12px 16px;
  border-radius: 30px;
  margin: 0 20px 20px 0;
  cursor: pointer;
`

export const NavItens = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 25px;
`
